import { render, staticRenderFns } from "./Unternehmen.vue?vue&type=template&id=e7104342&"
import script from "./Unternehmen.vue?vue&type=script&lang=js&"
export * from "./Unternehmen.vue?vue&type=script&lang=js&"
import style0 from "./Unternehmen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports